import { render, staticRenderFns } from "./PreventativeHealthPrecautions.vue?vue&type=template&id=53e13281&"
import script from "./PreventativeHealthPrecautions.vue?vue&type=script&lang=js&"
export * from "./PreventativeHealthPrecautions.vue?vue&type=script&lang=js&"
import style0 from "./PreventativeHealthPrecautions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports